export default "/assets/laying-bed1.116d096349682e08347b63d66da55a7d.png";